import React, { FC } from 'react'
import { Button } from 'components/Button'
import { useGenerateProjectReport } from 'services/project'
import styles from './GenerateReport.module.scss'
import { Area, Project } from 'models/project'
import { Icon } from 'components/Icon'
import { useTranslation } from 'react-i18next'
import { Spinner } from 'components/Spinner'
import { DateUtils } from 'utils/date'

type GenerateReportProps = {
  project: Project
  area?: Area
}

const iconForStatus = (status: string) => {
  if (status === 'loading') return <Spinner className={styles.spinner} />
  if (status === 'error') return <Icon name="download-line" />
  return <Icon name="download-line" />
}

const textForStatus = (status: string) => {
  if (status === 'loading') return 'download_charts.loading'
  if (status === 'error') return 'download_charts.try_again'
  return 'download_charts.cta'
}

export const GenerateReport: FC<GenerateReportProps> = ({ project, area }) => {
  const { t } = useTranslation()
  const [generateReport, { status }] = useGenerateProjectReport(project.id, area?.id as any)

  const downloadReport = () => {
    return generateReport(undefined, {
      onSuccess(file: File) {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(file)
        link.setAttribute('data-testid', 'report-download-link')
        link.setAttribute('download', `${project.name} - ${DateUtils.file()}.pdf`)
        link.click()
      },
    })
  }

  return (
    <Button
      className={styles.downloadCharts}
      onClick={downloadReport}
      disabled={status === 'loading'}
      variant={status === 'error' ? 'danger' : 'secondary'}
    >
      {t(textForStatus(status))}
      {iconForStatus(status)}
    </Button>
  )
}
